'use strict'

const hosts = {
  user: 'https://stg-user.hanatour.com',
  userMobile: 'https://stg-user-mobile.hanatour.com',
  seller: 'https://stg-seller.hanatour.com',
  hanatour: 'https://stgtour.hanatour.com',
  hanatourAccount: 'https://stg-accounts.hanatour.com',
  hanatourApi: 'https://api.hanatour.com',
  hanatourGw: 'https://stg-gw.hanatour.com',
  hanatourImg: 'https://image.hanatour.com',
  fndStatic: 'https://static.hanatour.com',
  hatsApi: 'https://hats.hanatour.com',
  hanatourPay: 'https://stg-pay.hanatour.com',
}

// 외부 API
const externalApi = {
  googleMap: {
    key: 'AIzaSyAKlC9AdN5hLaRGU83cbsaBQw8Y6EeDBC0',
  },
  googleAnalytic: {
    key: 'UA-23076506-21',
  },
}

module.exports = {
  hosts,
  externalApi,
  deployEnv: 'stg',
  axiosTimeout: 10000,
  gtxSellerIds: ['MHJ-S230516002'], // 글로벌틱스 seller id (환경 내에서도 계정이 여러개일 수 있다)
  jtrSellerIds: ['MHJ-S220623001', 'MHJ-S220811001'], // JTR seller id
  grlSellerIds: ['MHJ-S231121002'], // 고릴라 seller id
  rakutenGoraSellerIds: ['MHJ-S250509001'],
  kkdaySellerIds: ['MHJ-S250523001'], // kkday seller id
}
